module.exports = __webpack_public_path__ + "img/title-3.7e07a6ee.png";